import { SvgIcon, SvgIconProps } from "@mui/material";

const SubscriptionIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg
        enableBackground="new 0 0 468 468"
        viewBox="0 0 468 468"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <g>
            <g>
              <path d="m89.801 278.87h-15.095c-6.627 0-12-5.373-12-12s5.373-12 12-12h15.095c6.627 0 12 5.373 12 12s-5.373 12-12 12z" />
            </g>
            <g>
              <g>
                <path d="m248.303 218.187h-15.095c-6.627 0-12-5.373-12-12s5.373-12 12-12h15.095c6.627 0 12 5.373 12 12s-5.373 12-12 12z" />
              </g>
              <g>
                <path d="m327.554 218.187h-15.095c-6.627 0-12-5.373-12-12s5.373-12 12-12h15.095c6.627 0 12 5.373 12 12s-5.373 12-12 12z" />
              </g>
              <g>
                <path d="m169.052 218.187h-15.095c-6.627 0-12-5.373-12-12s5.373-12 12-12h15.095c6.627 0 12 5.373 12 12s-5.373 12-12 12z" />
              </g>
            </g>
            <g>
              <g>
                <path d="m169.052 339.554h-15.095c-6.627 0-12-5.373-12-12s5.373-12 12-12h15.095c6.627 0 12 5.373 12 12s-5.373 12-12 12z" />
              </g>
              <g>
                <path d="m89.801 339.554h-15.095c-6.627 0-12-5.373-12-12s5.373-12 12-12h15.095c6.627 0 12 5.373 12 12s-5.373 12-12 12z" />
              </g>
            </g>
            <g>
              <circle cx="161.504" cy="265.859" r="20.228" />
            </g>
          </g>
          <g>
            <path d="m343.736 219.472c-34.75 0-66.207 14.344-88.78 37.414-1.904-1.271-4.191-2.015-6.653-2.015h-15.095c-6.627 0-12 5.373-12 12s5.373 12 12 12h4.578c-11.61 18.894-18.315 41.11-18.315 64.865 0 68.52 55.745 124.265 124.264 124.265s124.265-55.746 124.265-124.266-55.745-124.263-124.264-124.263zm0 224.528c-55.286 0-100.264-44.979-100.264-100.265 0-55.285 44.979-100.264 100.264-100.264s100.264 44.979 100.264 100.264c0 55.286-44.979 100.265-100.264 100.265z" />
            <path d="m376.26 32.403h-31.65v-20.403c0-6.627-5.373-12-12-12s-12 5.373-12 12v20.403h-63.654v-20.403c0-6.627-5.373-12-12-12s-12 5.373-12 12v20.403h-63.654v-20.403c0-6.627-5.373-12-12-12s-12 5.373-12 12v20.403h-63.653v-20.403c0-6.627-5.373-12-12-12s-12 5.373-12 12v20.403h-31.649c-14.336 0-26 11.663-26 26v317.857c0 14.337 11.664 26 26 26h155.54c6.627 0 12-5.373 12-12s-5.373-12-12-12h-155.54c-1.103 0-2-.897-2-2v-233.074h354.26v28.354c0 6.627 5.373 12 12 12s12-5.373 12-12v-113.137c0-14.337-11.664-26-26-26zm-352.26 26c0-1.103.897-2 2-2h31.649v18.342c0 6.627 5.373 12 12 12s12-5.373 12-12v-18.342h63.653v18.342c0 6.627 5.373 12 12 12s12-5.373 12-12v-18.342h63.654v18.342c0 6.627 5.373 12 12 12s12-5.373 12-12v-18.342h63.654v18.342c0 6.627 5.373 12 12 12s12-5.373 12-12v-18.342h31.649c1.103 0 2 .897 2 2v60.782h-354.259z" />
            <g>
              <path d="m385.827 290.789-11.397-24.307c-2.814-6.001-9.961-8.582-15.959-5.771-5.436 2.55-8.053 8.652-6.407 14.24-2.606-.31-5.236-.483-7.884-.483-38.134 0-69.158 32.238-69.158 71.864 0 6.627 5.373 12 12 12s12-5.373 12-12c0-26.37 20.224-47.826 45.095-47.862-5.468 9.698 4.689 21.282 15.046 16.977l20.407-8.482c6.101-2.538 9.09-10.133 6.257-16.176z" />
              <path d="m387.333 387.479c-4.02-5.27-11.55-6.281-16.819-2.263-7.703 5.876-16.81 8.982-26.335 8.982-4.66 0-9.244-.775-13.606-2.241 3.705-2.582 5.798-7.146 4.977-11.889-1.131-6.53-7.338-10.911-13.871-9.777l-22.364 3.871c-6.836 1.185-11.381 8.345-9.512 15.048l6.454 23.14c3.068 10.999 18.875 11.587 22.811.915 7.919 3.217 16.42 4.934 25.111 4.934 14.831 0 28.971-4.807 40.892-13.9 5.269-4.021 6.282-11.551 2.262-16.82z" />
            </g>
          </g>
          <g>
            <circle cx="400.451" cy="356.891" r="14" />
          </g>
        </g>
      </svg>
    </SvgIcon>
  );
};

export default SubscriptionIcon;
